import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  // Admin-only login
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData, true); // Always admin login

    if (result.success) {
      navigate('/');
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="auth-wrapper">
      <aside className="auth-hero">
        <div className="auth-hero-inner">
          <div style={{ marginBottom: '2rem' }}>
            <img
              src="https://taxntips.com/nav-logo.png"
              alt="TaxnTip Logo"
              style={{ height: '56px', width: 'auto' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
          <h1 className="auth-hero-title">
            Hello
            <span style={{
              marginLeft: '0.5rem',
              background: `linear-gradient(45deg, var(--orange-light), var(--orange-dark))`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>TaxnTip!</span>
          </h1>
          <p className="auth-hero-subtitle">
            Secure admin access. Be productive and save time with streamlined tools.
          </p>
        </div>
      </aside>

      <main className="auth-panel">
        <div className="auth-panel-header">
          <h2 className="auth-panel-title">Welcome back!</h2>
        </div>
        <div className="card auth-card">
          <div className="card-body">
            <div style={{ marginBottom: '1.25rem' }}>
              <p className="auth-muted" style={{ marginTop: '0.25rem' }}>Admin Panel Login</p>
            </div>

            {error && (
              <div className="alert alert-error" style={{ marginBottom: '1rem' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="you@example.com"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your password"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%' }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner" style={{ width: '16px', height: '16px' }}></div>
                    Login Now
                  </>
                ) : (
                  'Login Now'
                )}
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Login;
